module.exports = __webpack_public_path__ + "static/media/detail_0006_f.bb16f19b.jpg";